import { useContext, useMemo } from 'react';
import { CategoryContext } from '../contexts';
import useCategory from './useCategory';
import useHome from './useHome';
import { ICategory } from '../types';

export default function useCategoryFragment(
  categoryId?: string
): ICategory | undefined {
  const categoryFragment = useContext(CategoryContext);
  const category = useCategory();
  const home = useHome();

  const value = useMemo(() => {
    if (!categoryId) {
      if (categoryFragment) return categoryFragment;
      if (category)
        return {
          id: category.id,
          title: category.title,
          slug: category.slug,
          featuredImageUrl: category.featuredImageUrl,
          articles: category.articles,
        };
      return undefined;
    }

    if (categoryFragment && categoryFragment.id === categoryId) {
      return categoryFragment;
    }

    if (category) {
      if (category.id === categoryId) {
        return {
          id: category.id,
          title: category.title,
          slug: category.slug,
          featuredImageUrl: category.featuredImageUrl,
          articles: category.articles,
        };
      }

      const sub = (category.subCategories || []).find(
        (_sub) => _sub.id === categoryId
      );
      if (sub) {
        return sub;
      }
    }

    if (home && home.categories) {
      const _category = home.categories.find((c) => c.id === categoryId);
      if (_category) {
        return {
          id: _category.id,
          title: _category.title,
          slug: _category.slug,
          featuredImageUrl: _category.featuredImageUrl,
          articles: _category.articles,
        };
      }
    }

    return undefined;
  }, [categoryId, categoryFragment, category, home]);

  return value;
}
